<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} cuadre agencia
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="preSave()">
          <div class="row">
            <div class="col-lg-6 m-b-15">
              <label>Seleccionar Agencia<span class="required"></span>
                <ng-container *ngIf="agencySelected != null">
                  <span class="m-l-15 bold"><i class="fas fa-phone m-r-5"></i>{{agencySelected.cellphone}}</span>
                </ng-container>
              </label>
              <ng-container *ngIf="agencySelected != null">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm" disabled
                    value="{{agencySelected.tradename}}-{{agencySelected.document_str}}">
                  <div class="input-group-append bg-custom b-0 removeClient">
                    <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                      uib-tooltip="Quitar" (click)="removeAgencies()">
                      <i class="fas fa-backspace w-100 f-s-12"></i>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="agencySelected == null">
                <component-search-agencies [classSize]="'search-small'"
                  (selectedAgenciesEvent)="selectedAgenciesSearch($event)" class="w-100">
                </component-search-agencies>
              </ng-container>
            </div>
            <div class="col-lg-6 form-group">
              <label>Observación</label>
              <input type="text" class="form-control" formControlName="observation">
            </div>
            <ng-container *ngIf="agencySelected != null">
              <div class="col-lg-12">
                <p class="form__group__title"><i class="fas fa-arrow-right text-danger m-r-5"></i> TRASPASOS PENDIENTES
                </p>
                <div class="table-responsive">
                  <table class="table mb-0 table-sm">
                    <thead class="thead-default">
                      <tr>
                        <th class="w-5"></th>
                        <th>Responsable y Código</th>
                        <th class="nowrap">Hotel / Ubicacion</th>
                        <th>Tour</th>
                        <th class="text-center">N° PAX</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">P. Corporativo</th>
                        <th class="text-center">C. Delegada</th>
                        <th class="text-center">Obs.</th>
                        <th class="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="transfers.length == 0">
                        <tr>
                          <td colspan="7">
                            No se encontraron registros.
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="transfers.length > 0">
                        <tr *ngFor="let item of transfers; let index_ = index">
                          <td class="w-5">
                            <div class="custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" value="{{item.id}}"
                                id="booking_transfer_{{item.id}}" (change)="selectedTransfers(item)">
                              <label class="custom-control-label p-t-3" for="booking_transfer_{{item.id}}"></label>
                            </div>
                          </td>
                          <td>
                            {{item.client_fullname}} <span class="m-l-2 f-s-10">({{item.client_cellphone}})</span>
                            <p class="m-b-2 f-s-11 bold" style="color: #a56b6b;">
                              {{item.code}}
                              <span class="badge badge-info f-s-9 m-l-3" *ngIf="item.is_received">Recibido</span>
                            </p>  
                          </td>
                          <td>{{item.reference_location}}</td>
                          <td>{{item.tour}}</td>
                          <td class="text-center">
                            {{item.quantity}}
                          </td>
                          <td class="text-center">
                            {{item.date_assigned}}
                          </td>
                          <td class="text-center">
                            {{toolsService.momeySol()}}{{item.price_corporate}}
                          </td>
                          <td class="text-center">
                            <ng-container *ngIf="item.delegated_payment != null">
                              {{toolsService.momeySol()}}{{item.delegated_payment}}
                            </ng-container>
                          </td>
                          <td class="f-s-10">
                            {{item.observation}}
                          </td>
                          <td class="text-center">
                            {{toolsService.momeySol()}}{{item.price_corporate * item.quantity}}
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                    <tfoot *ngIf="transfers_selecteds.length > 0">
                      <tr class="bold">
                        <td colspan="9" class="text-right">RESUMEN TOTAL TRASPASOS</td>
                        <td class="text-center bold f-s-12">
                          {{toolsService.momeySol()}}{{total_transfers}}
                        </td>
                      </tr>
                      <tr class="bold">
                        <td colspan="9" class="text-right"><i class="fas fa-info-circle m-l-5"></i> Cobros delegados
                        </td>
                        <td class="text-center bold f-s-12">- {{toolsService.momeySol()}}{{total_delegated_payment}}</td>
                      </tr>
                      <tr class="bold text-danger f-s-12">
                        <td colspan="9" class="text-right">BALANCE TRASPASOS</td>
                        <td class="text-center bold">{{toolsService.momeySol()}}{{ (total_transfers - total_delegated_payment)}}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

              </div>

              <div class="col-lg-12 m-t-25">
                <p class="form__group__title"><i class="fas fa-arrow-left text-success m-r-5"></i> RECIBIDOS
                  PENDIENTES</p>
                <div class="table-responsive">
                  <table class="table mb-0 table-sm">
                    <thead class="thead-default">
                      <tr>
                        <th class="w-5"></th>
                        <th>Responsable y Código</th>
                        <th>Hotel / Ubicacion</th>
                        <th>Tour</th>
                        <th class="text-center">N° PAX</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">P. Corporativo</th>
                        <th class="text-center"> C. Asignada</th>
                        <th class="text-center">Obs.</th>
                        <th class="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="receiveds.length == 0">
                        <tr>
                          <td colspan="7">
                            No se encontraron registros.
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="receiveds.length > 0">
                        <tr *ngFor="let item of receiveds; let index_ = index">
                          <td class="w-5">
                            <div class="custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" value="{{item.id}}"
                                id="booking_received_{{item.id}}" (change)="selectedReceiveds(item)">
                              <label class="custom-control-label p-t-3" for="booking_received_{{item.id}}"></label>
                            </div>
                          </td>
                          <td>
                            {{item.client_fullname}} <span class="m-l-2 f-s-10">({{item.client_cellphone}})</span>
                            <p class="m-b-2 f-s-11 bold" style="color: #a56b6b;">{{item.code}}</p>
                          </td>
                          <td>{{item.reference_location}}</td>
                          <td>{{item.tour}}</td>
                          <td class="text-center">
                            {{item.quantity}}
                          </td>
                          <td class="text-center">
                            {{item.date_assigned}}
                          </td>
                          <td class="text-center">
                            {{toolsService.momeySol()}}{{item.price_corporate}}
                          </td>
                          <td class="text-center">
                            <ng-container *ngIf="item.assigned_payment != null">
                              {{toolsService.momeySol()}}{{item.assigned_payment}}
                            </ng-container>                            
                          </td>
                          <td class="f-s-10">
                            {{item.observation}}
                          </td>
                          <td class="text-center">
                            {{toolsService.momeySol()}}{{item.price_corporate * item.quantity}}
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                    <tfoot *ngIf="receiveds_selecteds.length > 0">
                      <tr class="bold">
                        <td colspan="9" class="text-right">RESUMEN TOTAL RECIBIDOS</td>
                        <td class="text-center bold f-s-12">{{toolsService.momeySol()}}{{total_receiveds}}
                        </td>
                      </tr>
                      <tr class="bold">
                        <td colspan="9" class="text-right"><i class="fas fa-info-circle m-l-5"></i>
                          Cobros asignados</td>
                        <td class="text-center bold f-s-12">- {{toolsService.momeySol()}}{{total_assigned_payment}}</td>
                      </tr>
                      <tr class="bold text-success f-s-12">
                        <td colspan="9" class="text-right">BALANCE RECIBIDOS</td>
                        <td class="text-center bold">{{toolsService.momeySol()}}{{ (total_receiveds - total_assigned_payment)}}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="agencySelected == null">
              <div class="col-lg-12">
                <p><i class="fas fa-info-circle m-r-5"></i>Debe seleccionar una agencia para cargar los datos.</p>
              </div>
            </ng-container>
            <ng-container *ngIf="transfers.length > 0 || receiveds.length > 0">
              <div class="form-group col-lg-12 form__footerBtn">
                <div class="text-right">
                  <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                  <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                    <i class="far fa-save m-r-5"></i>
                    <ng-container *ngIf="!isEdit">
                      Guardar
                    </ng-container>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
